export class Desktop {
  savingRate = 0;
  savingValue = 0;
  singleValue = 0;
  maxChilderAge = 0;
  singleIncomeValue = 0;
  dreadDisMinValue = 12000;
  annualCoverCost = 0;
  annualOrdinalCost = 0;
  showSanitary: boolean;
  ccnlSelected: boolean;
  theoryIncomeOption: boolean;
  theoryAnnualCost: number;
}
